import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import config from '../config'

const StyledLink = styled(Link)`
  color: ${config.navLinkColor};
  text-decoration:none;
  -moz-transition-property:color;
  -o-transition-property:color;
  -webkit-transition-property:color;
  transition-property:color;
  -moz-transition-duration:.2s;
  -o-transition-duration:.2s;
  -webkit-transition-duration:.2s;
  transition-duration:.2s;
  -moz-transition-timing-function:linear;
  -o-transition-timing-function:linear;
  -webkit-transition-timing-function:linear;
  transition-timing-function:linear;
  -moz-transition-delay:0s;
  -o-transition-delay:0s;
  -webkit-transition-delay:0s;
  transition-delay:0s
  &:hover { color: ${config.navLinkColorActive}; }
`

export default StyledLink



// WEBPACK FOOTER //
// ./src/components/StyledLink.js